<template>
  <div id="app">
    <TopBar />
    <router-view />
    <div
      class="developed-container"
      v-if="$route.meta.showLogo"
      :class="{ 'login-layout': $route.path === '/login' }"
    >
      <p>Sviluppato da</p>
      <div class="lt-logo-container">
        <a
          class="lt-logo-link"
          href="https://liberotratto.it/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visita liberotratto.it"
        >
          <img
            src="@/assets/libero_tratto_logo.png"
            alt="Libero Tratto — logo"
            class="lt-logo"
          />
        </a>
      </div>
    </div>
    <!-- Widget Assistenza/Feedback: montato SOLO sulle route autenticate, così viene
         (ri)creato dopo il login quando authIsCached() è già true (visible non è reattivo). -->
    <FeedbackWidget v-if="showFeedbackWidget" />
  </div>
</template>

<script>
import TopBar from "@/components/TopBar.vue"; // Percorso del componente TopBar
// import { ref, watch } from "vue";
// import { useRoute } from "vue-router";

export default {
  name: "App",
  components: {
    TopBar,
  },
  computed: {
    // Mostra il widget solo nell'area autenticata (route con meta.requiresAuth).
    // $route è reattivo: al passaggio login → /home il widget si monta fresh.
    showFeedbackWidget() {
      return this.$route.matched.some((route) => route.meta?.requiresAuth);
    },
  },
  // setup() {
  //   const route = useRoute();
  //   const breadcrumbs = ref([]);

  //   const generateBreadcrumbs = (currentRoute) => {
  //     return currentRoute.matched.map((matchedRoute) => ({
  //       name: matchedRoute.meta.breadcrumb || matchedRoute.name, // Usa il breadcrumb dal meta o il nome della rotta
  //       path: matchedRoute.path,
  //     }));
  //   };

  //   // Inizializza i breadcrumbs
  //   breadcrumbs.value = generateBreadcrumbs(route);

  //   // Osserva i cambiamenti della route e aggiorna i breadcrumbs
  //   watch(
  //     () => route.path,
  //     () => {
  //       breadcrumbs.value = generateBreadcrumbs(route);
  //     }
  //   );

  //   return { breadcrumbs };
  // },
};
</script>

<style src="@/css/App.css"></style>
